import { useState} from 'react';
import { useSelector} from 'react-redux';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AcrsApp = () => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [createModalShow, setCreateModalShow] = useState(false);
    const [selectedList, setSelectedList] = useState([]);

    return {
        DEV,
        permission,
        deleteModalShow,
        setDeleteModalShow,
        createModalShow,
        setCreateModalShow,
        selectedList,
        setSelectedList
    }
}

export default AcrsApp;
